import React, { useState } from 'react'
import NotificationBull from '../screens/refonte/shares/NotificationBull';

const useToast = () => {

    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("ceci est une notification");
    const [severity, setSeverity] = useState("success");
    const [autoHideDuration, setAutoHideDuration] = useState(3500);

    const showToast = (newSeverity = "success", newMessage, newAutoHideDuration = 3500) => {
        if (newMessage) {
            setMessage(newMessage);
        }
        if (newSeverity) {
            setSeverity(newSeverity);
        }
        if (newAutoHideDuration) {
            setAutoHideDuration(newAutoHideDuration);
        }
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    }

    const Toast = () => (
        <NotificationBull
            open={isOpen}
            severity={severity}
            message={message}
            autoHideDuration={autoHideDuration}
            handleCloseNotification={handleClose}
        />
    );

    return { showToast, Toast };
}

export default useToast